import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { FillActionContext } from "./FillActionContext";

function useGet() {
  const { setElement, setShowModal } = useContext(FillActionContext);
  const errorHandler = useErrorHandler();

  return (
    token: string,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get("public/invoice_accounts", token)
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
        setShowModal(true);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
